import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
  width?: string | number;
  height?: string | number;
}

const Skeleton: React.FC<SkeletonProps> = ({ className = '', variant = 'text', width, height }) => {
  const style: React.CSSProperties = {
    width,
    height,
  };

  return (
    <div 
      className={`skeleton skeleton--text ${variant} animate-pulse ${className}`}
      style={style}
    />
  );
};

export default Skeleton;
